import { FC } from 'react'

import { FooterProps } from './types'

const Footer: FC<FooterProps> = ({ children, className }) => {
  return <div className={`flex w-full ${className} `}>{children}</div>
}

export default Footer
